module.exports = __webpack_public_path__ + "img/bg.ee2ff970.jpg";